module.exports = __webpack_public_path__ + "static/media/loading-bars.5307e21e.svg";